/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import error from "./error";
import { sprintf } from "./utils";
import ChoiceStore from "data/meta/ChoiceStore";
import { auditable } from "audit";
import HybridConfig from "lib/HybridConfig";
import { optionsForField } from "data/selectors/options";
import asArray from "data/util/asArray";

export const buildState = function(info, code, message, unusual) {
    code = parseInt(((code == null) ? error.UNUSUAL.code : code).toString(10), 10);
    const {
        name: displayName,
        seqnum
    } = info;
    const state = {
        code,
        message: displayName + (message ? ` - ${message}` : seqnum ? " -" : "") + (seqnum ? ` (${seqnum})` : "")
    };
    state.isUnusual = (unusual != null) && unusual;
    return state;
};

const getValidationMessage = function(info, code) {
    if (code >= error.ILLEGAL.code) {
        return info.illegalMessage || error.ILLEGAL.message;
    }
    if (code >= error.WARNING.code) {
        return info.warningMessage || error.WARNING.message;
    }
    if (code >= error.MISSING.code) {
        return error.MISSING.message;
    }
    if (code >= error.UNUSUAL.code) {
        return error.UNUSUAL.message;
    }
    return error.OK.message;
};

const __conditional_choice = function(info, value, options) {
    value = asArray(value);
    const activeOpts = _.pluck(options, "name");
    const allOpts = ChoiceStore.getChoiceByKey(info.choiceKey).options.map(o =>
        o.name);
    // if any val in allOpts and not in activeOpts, error!
    for (const v of value) {
        if (allOpts.includes(v) && !(activeOpts.includes(v))) {
            return buildState(info, info.codes.inactive, sprintf(error.byCode(info.codes.inactive).message, v));
        }
    }
};

const _vfac_precision = (precision, code) =>
    ({
        code,
        getComp() { return precision; },
        doComp(comp, value) {
            const str = (typeof value) === "string" ? value : value.toString(10);
            const di = str.indexOf(".");
            return (str.length - (di >= 0 ? 1 : 0)) > (value < 0 ? comp + 1 : comp);
        }
    })
;

const _vfac_scale = (scale, code) =>
    ({
        code,
        getComp() { return scale; },
        doComp(comp, value) {
            const str = (typeof value) === "string" ? value : value.toString(10);
            const di = str.indexOf(".");
            if (di < 0) {
                return false;
            }
            return str.substr(di + 1).length > comp;
        }
    })
;

const _vfac_min = (compFn, code) =>
    ({
        code,
        getComp: compFn,
        doComp(comp, value) {
            return ArmusScript._op_gt(Number(comp), Number(value));
        }
    })
;

const _vfac_max = (compFn, code) =>
    ({
        code,
        getComp: compFn,
        doComp(comp, value) {
            return ArmusScript._op_lt(Number(comp), Number(value));
        }
    })
;

const doContinuousField = function(self, info, value, ...validators) {
    let comp;
    let v;
    const unusuals = [];
    if ((info.scripts.min != null) && (info.codes.min !== error.OK.code)) {
        validators.push(_vfac_min(info.scripts.min, info.codes.min));
    }
    if ((info.scripts.max != null) && (info.codes.max !== error.OK.code)) {
        validators.push(_vfac_max(info.scripts.max, info.codes.max));
    }
    if ((info.scripts.usualMin != null) && (info.codes.usualMin !== error.OK.code)) {
        unusuals.push(_vfac_min(info.scripts.usualMin, info.codes.usualMin));
    }
    if ((info.scripts.usualMax != null) && (info.codes.usualMax !== error.OK.code)) {
        unusuals.push(_vfac_max(info.scripts.usualMax, info.codes.usualMax));
    }
    let toString = (() => {
        if (info.mask != null) {
        if (info.type === "TimeField") {
            return v => ArmusScript["timeFormat(Time,String)"](v, info.mask);
        } else if (["DateField", "DateTimeField", "TZTimestampField"].includes(info.type)) {
            return v => ArmusScript["dateFormat(Date,String)"](v, info.mask);
        }
    }
    })();
    toString = toString || (it => it.toString());

    if (validators != null) {
        for (v of validators) { // disregard null/falsey validators
            if (v) {
                comp = v.getComp(self);
                if ((comp != null) && v.doComp(comp, value)) {
                    let unusual = false;
                    // have to check if it's unusual, even if it fails validation...
                    if (unusuals != null) {
                        for (const u of unusuals) {
                            const ucomp = u.getComp(self);
                            if ((ucomp != null) && u.doComp(ucomp, value)) {
                                unusual = true;
                                break;
                            }
                        }
                    }
                    return buildState(info, v.code, sprintf(error.byCode(v.code).message, toString(value), toString(comp)), unusual);
                }
            }
        }
    }
    if (unusuals != null) {
        for (v of unusuals) {
            comp = v.getComp(self);
            if ((comp != null) && v.doComp(comp, value)) {
                return buildState(info, v.code, sprintf(error.byCode(v.code).message, toString(value), toString(comp)), true);
            }
        }
    }
    return buildState(info, error.OK.code);
};

// info -> value -> vState
const _or_validate = function(info, value, self) {
    let maxLen, minLen;
    if (!info.dqr) {
        if (["AssociationField", "CompositionField"].includes(info.type)) {
            return buildState(info, error.OK.code);
        } else {
            (console.warn || console.log)(`${self.getKey()}.${info.key}'s validate function was called, but it's excluded from DQR.`);
            return; // no validation state for this field
        }
    }

    // if it's not enabled, it must be OK
    if (!self.isFieldEnabled(info)) {
        return buildState(info, error.OK.code);
    }

    // if it's missing, do that
    const isMissing = value == null || ((_.isArray(value) || value instanceof Backbone.Collection) && (value.length === 0));
    if (isMissing && info.codes.missing != null) {
        return buildState(info, info.codes.missing, "missing");
    }

    // run the validation function
    if (info.scripts.validation != null) {
        const v = info.scripts.validation(self);
        if (v instanceof Array) {
            // scream about old-old int[] returns
            console.error(`ValidationScript for '${self.constructor.KEY}.${info.key}' should return Validation or int; int[] is obsolete.`);
        } else if (typeof v === "number") {
            // support old int returns
            if (v !== error.OK.code) {
                return buildState(info, v, getValidationMessage(info, v));
            }
        } else if (v != null && v.code != null) {
            // modern valdiation returns
            if (v.code !== error.OK.code) {
                return buildState(info, v.code, v.message);
            }
        }
    }

    // no need to do type-specific value checks if it's missing
    if (isMissing) {
        return buildState(info, error.OK.code);
    }

    // at this point, we know it's enabled, it's not missing, and it passed the
    // explicit validation function (if one existed).

    // the "distributor"
    if (info.type === "IntegerField") {
        return doContinuousField(self, info, value,
            (info.precision != null) && _vfac_precision(info.precision, error.ILLEGAL_PRECISION.code)
        );
    } else if (info.type === "DecimalField") {
        return doContinuousField(self, info, value,
            (info.precision != null) && _vfac_precision(info.precision, error.ILLEGAL_PRECISION.code),
            (info.scale != null) && _vfac_scale(info.scale, error.ILLEGAL_SCALE.code)
        );
    } else if (["DateField", "DateTimeField", "IntervalField", "TimeField", "TZTimestampField"].includes(info.type)) {
        return doContinuousField(self, info, value);
    } else if (info.type === "StringField") {
        minLen = info.scripts.minLength && info.scripts.minLength(self);
        maxLen = info.scripts.maxLength && info.scripts.maxLength(self);
        if ((minLen != null) && ArmusScript._op_gt(minLen, value.length)) {
            return buildState(info, info.codes.minLength, sprintf(error.byCode(info.codes.minLength).message, value, minLen.toString()));
        }
        if ((maxLen != null) && ArmusScript._op_lt(maxLen, value.length)) {
            return buildState(info, info.codes.maxLength, sprintf(error.byCode(info.codes.maxLength).message, value, maxLen.toString()));
        }
        return buildState(info, error.OK.code);
    } else if (info.type === "FileField") {
        minLen = info.scripts.minLength && info.scripts.minLength(self);
        maxLen = info.scripts.maxLength && info.scripts.maxLength(self);
        // value is either a FileInfo, or a Array/Collection of them
        for (const it of (value instanceof Backbone.Collection ? value.models : _.isArray(value) ? value : (value != null) ? [value] : [])) {
            if ((minLen != null) && ArmusScript._op_gt(minLen, it.size)) {
                return buildState(info, info.codes.minLength, sprintf(error.byCode(info.codes.minLength).message, it.filename, minLen.toString()));
            }
            if ((maxLen != null) && ArmusScript._op_lt(maxLen, it.size)) {
                return buildState(info, info.codes.maxLength, sprintf(error.byCode(info.codes.maxLength).message, it.filename, maxLen.toString()));
            }
        }
        return buildState(info, error.OK.code);
    } else if (info.type === "ChoiceField") {
        if (info.multiValued && (info.codes.atomic !== error.OK.code)) {
            // do atomicity check first
            const c = ChoiceStore.getChoiceByKey(info.choiceKey);
            if (c.atomic && _.isArray(value) && (value.length > 1)) {
                // there are at least two options, so bomb if any are atomic
                for (const v of value) {
                    if (c.options.some(o => o.atomic && o.name === v)) {
                        return buildState(info, info.codes.atomic, sprintf(error.byCode(info.codes.atomic).message, v));
                    }
                }
            }
        }
        const s = __conditional_choice(info, value, optionsForField(
            info,
            self,
            ChoiceStore.getChoiceByKey(info.choiceKey),
        ));
        if (s != null) { return s; }
        return buildState(info, error.OK.code);
    } else {
        return buildState(info, error.OK.code);
    }
};

export default HybridConfig.auditScriptlets()
    ? auditable("validate", _or_validate)
    : _or_validate;



// WEBPACK FOOTER //
// ./app/jsmodel/_or_validate.js